// import axiosInstance from "./axiosInstance";

// const dutyRosterService = {
//     create: async (payload) => {
//         try {
//             const response = await axiosInstance.post('/duty-roster/create', payload);
//             return response.data;
//         } catch (error) {
//             console.error("API Error:", error.response?.data || error.message);
//             throw error.response.data;
//         }
//     },
//     fetchAll: async () => {
//         try {
//             const response = await axiosInstance.get('/duty-roster/all');
//             return response.data;
//         } catch (error) {
//             throw error.response.data;
//         }
//     },
//     fetchTotal: async () => {
//         try {
//             const response = await axiosInstance.get('/duty-roster/total');
//             return response.data;
//         } catch (error) {
//             throw error.response.data;
//         }
//     },
//     fetchTodayCounts: async () => {
//         try {
//             const response = await axiosInstance.get('/duty-roster/today-counts');
//             return response.data;
//         } catch (error) {
//             throw error.response.data;
//         }
//     },
//     fetchByDate: async (date, shift = null) => {
//         try {
//             const params = shift ? `?date=${date}&shift=${shift}` : `?date=${date}`;
//             const response = await axiosInstance.get(`/duty-roster/by-date${params}`);
//             return response.data;
//         } catch (error) {
//             throw error.response.data;
//         }
//     },
//     fetchById: async (id) => {
//         try {
//             const response = await axiosInstance.get(`/duty-roster/get/${id}`);
//             return response.data;
//         } catch (error) {
//             throw error.response.data;
//         }
//     },
//     update: async (id, payload) => {
//         try {
//             const response = await axiosInstance.put(`/duty-roster/edit/${id}`, payload);
//             return response.data;
//         } catch (error) {
//             throw error.response.data;
//         }
//     },
//     delete: async (id) => {
//         try {
//             const response = await axiosInstance.delete(`/duty-roster/delete/${id}`);
//             return response.data;
//         } catch (error) {
//             throw error.response.data;
//         }
//     },
// };

// export default dutyRosterService;

import axiosInstance from "./axiosInstance";

const dutyRosterService = {
    create: async (payload) => {
        try {
            const response = await axiosInstance.post('/duty-roster/create', payload);
            return response.data;
        } catch (error) {
            console.error("API Error:", error.response?.data || error.message);
            throw error.response.data;
        }
    },
    fetchAll: async () => {
        try {
            const response = await axiosInstance.get('/duty-roster/all');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetchTotal: async () => {
        try {
            const response = await axiosInstance.get('/duty-roster/total');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetchTodayCounts: async () => {
        try {
            const response = await axiosInstance.get('/duty-roster/today-counts');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetchByDate: async (date = null, shift = null) => {
        try {
            const query = [];
            if (date) query.push(`date=${date}`);
            if (shift) query.push(`shift=${shift}`);
            const queryString = query.length ? `?${query.join("&")}` : "";
            const response = await axiosInstance.get(`/duty-roster/by-date${queryString}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetchById: async (id) => {
        try {
            const response = await axiosInstance.get(`/duty-roster/get/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    update: async (id, payload) => {
        try {
            const response = await axiosInstance.put(`/duty-roster/edit/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    delete: async (id) => {
        try {
            const response = await axiosInstance.delete(`/duty-roster/delete/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
};

export default dutyRosterService;